import { useCallback, useState } from "react";
import { Form, Input, Button, Typography, message } from "antd";
import { useNavigate } from "react-router-dom";
import LogoImage from "../../../assets/images/logo.png";
import { loginThunk } from "../../../store/auth/thunks";
import { useDispatch } from "react-redux";
import { ROUTES } from "../../../constant/routes";
import ForgotPasswordModal from "../ForgotPasswordModal";
import { StyledSignin } from "./styles";

const Signin = () => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [forgotPasswordModal, setForgotPasswordModal] = useState(false);

  const onFinish = useCallback(async (values) => {
    try {
      setLoading(true);

      const { payload } = await dispatch(loginThunk(values));
      if (payload?.code === 403) {
        setShowNewPassword(true);
        message.warning("Please set a new password");
      }
      //@ts-ignore
      if (payload?.id) navigate("/dashboard");
    } catch (error) {
      message.error("Invalid credentials");
    } finally {
      setLoading(false);
    }
  }, []);

  return (
    <>
      <StyledSignin className="auth-right">
        <div className="right-header">
          <h2>Welcome back 👋</h2>
          <p>Sign in to your workspace to continue</p>
        </div>

        <Form layout="vertical" disabled={loading} onFinish={onFinish}>
          <Form.Item
            label="Email"
            name="email"
            rules={[
              { required: true, message: "Please input your email!" },
              { type: "email", message: "Invalid email format!" },
            ]}
          >
            <Input placeholder="you@company.com" />
          </Form.Item>

          <Form.Item
            label="Password"
            name="password"
            rules={[{ required: true, message: "Please input your password!" }]}
          >
            <Input.Password placeholder="Enter your password" />
          </Form.Item>

          <div className="forgot-link">
            <Typography.Link onClick={() => setForgotPasswordModal(true)}>
              Forgot Password?
            </Typography.Link>
          </div>

          {showNewPassword && (
            <Form.Item
              label="New Password"
              name="new_password"
              rules={[
                {
                  required: true,
                  message: "Please input your new password!",
                },
                {
                  min: 8,
                  message: "Password must be at least 8 characters!",
                },
              ]}
            >
              <Input.Password placeholder="Enter your new password" />
            </Form.Item>
          )}

          <Form.Item style={{ marginTop: "1.5rem", marginBottom: "12px" }}>
            <Button type="primary" htmlType="submit" loading={loading} block>
              Sign In
            </Button>
          </Form.Item>

          <div className="signup-row">
            Don't have an account?
            <Typography.Link href={ROUTES.SIGNUP}>
              &nbsp;Sign Up
            </Typography.Link>
          </div>
        </Form>
      </StyledSignin>
      {forgotPasswordModal && (
        <ForgotPasswordModal onClose={() => setForgotPasswordModal(false)} />
      )}
    </>
  );
};

export default Signin;
